<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページにはnoindexタグが設定されていません。
        </p>
        <p v-else>
          あなたのWebページにはnoindexタグが設定されています。
        </p>
      </div>
    </li>
    <li v-if="noIndexes.length" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <ul class="c-list--disc">
          <li v-for="(item, index) in noIndexes" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          あなたのWebページにはnoindexタグが設定されています。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    noIndexes() {
      if (this.detail.noindex) {
        return this.detail.noindex.filter(item => item);
      }
      return [];
    }
  }
};
</script>
